import Col from "components/ui-elements/Col";
import React from "react";
import Input from "./Input";
const InputCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <Input {...rest} />
    </Col>
  );
};

InputCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-1"
}

export default InputCol;